import { Image } from '@domain-group/suit-theme'

import type { ImageModel } from '@models/types'

import placeholderImageUrl from '../../assets/default_campaign_image_400x400.png'

const Tile = (props: {image: ImageModel}) => {
  const { image: { square_url } } = props

  return (
    <Image
      borderRadius="5px"
      boxProps={{ minHeight: 100 }}
      placeholderUrl={placeholderImageUrl}
      url={square_url}
      width="100%"
    />
  )
}

export default Tile
